import { useState } from 'react';
import { Check, Copy } from 'lucide-react';
import { Button } from '@/components/ui/Button';
import { useToast } from '@/lib/toast';
import { nachlieferungText, type NachlieferungTitel } from '@/lib/nachlieferung';

/**
 * „Nachlieferungs-Text kopieren" — für den Rechnungs-Vortext in BONUS
 * (E52). Steht an zwei Orten: im Teilsendungs-Dialog, weil dort die erste
 * Rechnung entsteht, und über den Positionen, solange die Nachlieferung
 * offen ist. Nur am PC: BONUS läuft dort, am Tablet gäbe es nichts,
 * wohin man den Satz einfügen könnte. Das entscheidet der Aufrufer.
 */
export function NachlieferungKopieren({ titel }: { titel: readonly NachlieferungTitel[] }) {
  const toast = useToast();
  const [kopiert, setKopiert] = useState(false);
  const satz = nachlieferungText(titel);
  if (satz === null) return null;

  async function kopieren(): Promise<void> {
    try {
      await navigator.clipboard.writeText(satz as string);
      setKopiert(true);
      setTimeout(() => setKopiert(false), 2000);
    } catch {
      toast('error', 'Kopieren ging nicht — die Zwischenablage ist gesperrt.');
    }
  }

  return (
    <div className="flex flex-wrap items-center gap-2" data-testid="nachlieferung-kopieren">
      <Button variant="secondary" onClick={() => void kopieren()} title={satz}>
        {kopiert ? <Check className="h-4 w-4" /> : <Copy className="h-4 w-4" />}
        {kopiert ? 'Kopiert' : 'Nachlieferungs-Text kopieren'}
      </Button>
      <span className="min-w-0 text-xs text-ink-faint">für den Rechnungs-Vortext in BONUS</span>
    </div>
  );
}
